// extracted by mini-css-extract-plugin
module.exports = {"customDateInput":"selfreadingdate_customDateInput__Xzxhb"};